import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Unit', 'Description'];

export const PurchaseUnitsDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: unitOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /units',
    labelAttribute: 'description',
    valueAttribute: 'unit',
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={unitOptions} columnNames={COLUMN_NAMES} />;
};
